<template>
  <base-modal :size="'xxl'" :modal-id="'add-bi-modal'" :is-modal-open="isOpen" hide-footer @hide="onCloseModal">
    <template #modal-header>
      <div class="add-bi-header-wrp font-f2">
        <add-icon class="add-bi-icon" />
        {{ t('bi.add_chart') }}
      </div>
    </template>
    <template #modal-body>
      <div class="add-bi-content-container">
        <div class="add-bi-filter-wrp">
          <div class="add-bi-filter-section">
            <label class="add-bi-select-label">{{ t('bi.data_type') }}:</label>
            <add-bi-dropdown :name="'data'" :options="data" :dropdown-select="dropdownSelect.chartDataType" @on-select="onFilterChange" />
          </div>
          <div class="add-bi-filter-section">
            <label class="add-bi-select-label">{{ t('bi.source') }}:</label>
            <add-bi-dropdown :name="'source'" :options="source" :dropdown-select="dropdownSelect.sourceTypeDescription" @on-select="onFilterChange" />
          </div>
          <div class="add-bi-filter-section">
            <label class="add-bi-select-label">{{ t('bi.chart_type') }}:</label>
            <add-bi-dropdown :name="'chart-type'" :options="chartType" :dropdown-select="dropdownSelect.chartTypeName" @on-select="onFilterChange" />
          </div>
          <div class="add-bi-filter-section search">
            <search-button
              class="button-item"
              v-model="searchKeyword"
              @update:model-value="onFilterChange"
              :disabled="!chartSetFiltered.length || loading"
            />
          </div>
        </div>
        <div class="add-bi-show-selector-wrp show">
          {{ t('bi.selected') }}<span class="add-bi-value-select">{{ chartSetSelectedList.length }}</span
          ><span class="add-bi-total-select">/{{ chartSetFiltered.length }}</span>
        </div>
        <div v-if="!loading" class="add-bi-item-wrp">
          <add-bi-item
            v-for="item in chartSetFiltered"
            :key="item.chartName"
            :chart-set-selected-list="chartSetSelectedList"
            :item="item"
            @select-chart="onSelectedChartSetItem"
          />
        </div>
        <div v-else class="loading">
          <loader-spinner />
        </div>
        <!--        TODO: should be in action or footer instead-->
        <div class="add-bi-item-action-wrp">
          <button class="add-bi-btn-cancel" @click="onCloseModal">{{ t('bi.cancel') }}</button>
          <button v-if="loading && chartSetFiltered.length > 0" class="add-bi-btn-add" type="button" disabled>
            {{ t('bi.add') }}
            <span class="ml-sm spinner-border spinner-border-sm" role="status"></span>
          </button>
          <div v-else>
            <button class="add-bi-btn-add" :disabled="chartSetSelectedList.length === 0 || loading" @click="onAddNewChart">
              {{ t('bi.add') }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script lang="ts" setup>
// libs
import { useI18n } from 'vue-i18n';

//component
import BaseModal from '@/views/components/modal/BaseModal.vue';
import AddBiDropdown from './AddBiDropdown.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';
import SearchButton from '@/views/components/button/IconButton/SearchButton.vue';

//icon
import AddIcon from '@/assets/icons/base/button/AddIcon.vue';

//hook
import useOptions from './hooks/useOptions';
import useAddBiModal from './hooks/useAddBiModal';
import AddBiItem from './AddBiItem.vue';

interface Props {
  isOpen: boolean;
  moduleId: number;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
  moduleId: 1,
});

defineEmits(['cancel', 'add-new-chart', 'close-modal']);

const { t } = useI18n();

const { data, source, chartType } = useOptions();
const {
  loading,
  chartSetFiltered,
  chartSetSelectedList,
  dropdownSelect,
  onCloseModal,
  onSelectedChartSetItem,
  onAddNewChart,
  onFilterChange,
  searchKeyword,
} = useAddBiModal(props);
</script>

<style lang="scss">
@import '@/assets/styles/modules/analytics/bi/analytics-add-bi-modal.scss';
</style>
